var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"template-view",class:{
        'template-view--flip-turn': !_vm.bookLike,
        'template-view--page-turn': _vm.bookLike,
    }},[_c('div',{staticClass:"template-wrapper"},[_c('div',{staticClass:"template-container"},[_c('div',[(_vm.template)?_c('app-card',{attrs:{"template":_vm.template,"bookLike":_vm.bookLike}}):_vm._e()],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }